<h2 mat-dialog-title>
  <mat-icon class="title-icon">menu_book</mat-icon>
  Report Field Glossary
</h2>

<mat-dialog-content>
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search fields...</mat-label>
      <input matInput
             [(ngModel)]="searchTerm"
             (ngModelChange)="onSearchChange()"
             data-testid="glossary-search-input"
             placeholder="Type to search...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <span class="results-count" data-testid="glossary-results-count" *ngIf="searchTerm">
      {{ getTotalResults() }} result(s) found
    </span>
  </div>

  <mat-accordion multi>
    @for (section of sections; track section) {
      @if (hasResults(section)) {
        <mat-expansion-panel [expanded]="!searchTerm">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ section }}
            </mat-panel-title>
            <mat-panel-description>
              {{ filteredDefinitionsBySection.get(section)?.length }} field(s)
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="definitions-list">
            @for (definition of filteredDefinitionsBySection.get(section); track definition.key) {
              <div class="definition-item">
                <div class="definition-label" data-testid="glossary-definition-label">{{ definition.label }}</div>
                <div class="definition-description">{{ definition.description }}</div>
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    }
  </mat-accordion>

  @if (getTotalResults() === 0 && searchTerm) {
    <div class="no-results" data-testid="glossary-no-results">
      <mat-icon>search_off</mat-icon>
      <p>No fields match your search "{{ searchTerm }}"</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
